import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import PaymentMethods from '@/components/payment-methods';

export default function AccountPaymentMethodsScreen() {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <PaymentMethods />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
